// extracted by mini-css-extract-plugin
export default {"icon":"HistoryEventIcon_icon__7y9NT"};